import {
    ArrowUpOutlined,
    CompressOutlined,
    EditOutlined,
    FileImageOutlined,
    FileTextOutlined,
    MergeCellsOutlined,
    PictureOutlined,
    ScissorOutlined,
    UnlockOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Card, Col, Row, Space, Tag, Typography } from "antd";
import { useState } from "react";
import UploadingImageModal from "./UploadImageModal";

const { Title, Text } = Typography;

export const toolsData = [
    {
        key: "image-resizer",
        title: "Image Resizer",
        category: "Image Tools",
        description: "Resize images to desired dimensions",
        icon: <PictureOutlined style={{ fontSize: 24, color: "#f39c12" }} />,
        type: "Image Tools",
    },
    {
        key: "image-cropper",
        title: "Image Crop",
        category: "Image Tools",
        description: "Crop images to focus on important areas",
        icon: <PictureOutlined style={{ fontSize: 24, color: "#ff6b6b" }} />,
        type: "Image Tools",
    },
    {
        key: "content-improver",
        title: "Content Improver",
        category: "AI Write",
        description: "Enhance your content with AI suggestions",
        icon: <EditOutlined style={{ fontSize: 24, color: "#8e44ad" }} />,
        type: "AI Write",
    },
    {
        key: "paragraph-writer",
        title: "Paragraph Writer",
        category: "AI Write",
        description: "Write well-structured paragraphs with AI",
        icon: <FileTextOutlined style={{ fontSize: 24, color: "#ff6b6b" }} />,
        type: "AI Write",
    },
    {
        key: "ai-image-generator",
        title: "AI Image Generator",
        category: "Image Tools",
        description: "Generate images using AI",
        icon: <PictureOutlined style={{ fontSize: 24, color: "#f39c12" }} />,
        type: "Image Tools",
    },
    {
        key: "remove-background",
        title: "Remove Background",
        category: "Image Tools",
        description: "Remove backgrounds from images effortlessly",
        icon: <ScissorOutlined style={{ fontSize: 24, color: "#00a8ff" }} />,
        type: "Image Tools",
    },
    {
        key: "merge-pdf",
        title: "Merge PDF",
        category: "PDF Tools",
        description: "Combine multiple PDFs into one",
        icon: <MergeCellsOutlined style={{ fontSize: 24, color: "#9b59b6" }} />,
        type: "PDF Tools",
    },
    {
        key: "edit-pdf",
        title: "Edit PDF",
        category: "PDF Tools",
        description: "Edit PDF files with ease",
        icon: <EditOutlined style={{ fontSize: 24, color: "#f1c40f" }} />,
        type: "PDF Tools",
    },
    {
        key: "pdf-to-jpg",
        title: "PDF to JPG",
        category: "PDF Tools",
        description: "Convert PDF pages to JPG images",
        icon: <FileImageOutlined style={{ fontSize: 24, color: "#f1c40f" }} />,
        type: "PDF Tools",
    },
    {
        key: "jpg-to-pdf",
        title: "JPG to PDF",
        category: "PDF Tools",
        description: "Convert images to PDF format",
        icon: <FileImageOutlined style={{ fontSize: 24, color: "#f1c40f" }} />,
        type: "PDF Tools",
    },
    {
        key: "upscale-image",
        title: "Upscale Image",
        category: "Image Tools",
        description: "Enhance image resolution",
        icon: <ArrowUpOutlined style={{ fontSize: 24, color: "#f39c12" }} />,
        type: "Image Tools",
    },
    {
        key: "compress-image",
        title: "Compress Image",
        category: "Image Tools",
        description: "Reduce image file size",
        icon: <CompressOutlined style={{ fontSize: 24, color: "#e74c3c" }} />,
        type: "Image Tools",
    },
    {
        key: "paragraph-completer",
        title: "Paragraph Completer",
        category: "AI Write",
        description: "Complete paragraphs with AI assistance",
        icon: <FileTextOutlined style={{ fontSize: 24, color: "#ff6b6b" }} />,
        type: "AI Write",
    },
    {
        key: "remove-pdf-password",
        title: "Remove PDF Password",
        category: "PDF Tools",
        description: "Unlock password-protected PDFs",
        icon: <UnlockOutlined style={{ fontSize: 24, color: "#2ecc71" }} />,
        type: "PDF Tools",
    },
    {
        key: "split-pdf",
        title: "Split PDF",
        category: "PDF Tools",
        description: "Split a PDF into multiple files",
        icon: <ScissorOutlined style={{ fontSize: 24, color: "#3498db" }} />,
        type: "PDF Tools",
    },
];

const categories = ["All Tools", "Image Tools", "PDF Tools", "AI Write"];

const ToolsGrid = ({ onSelectTool }) => {
    const [activeCategory, setActiveCategory] = useState("All Tools");

    const visibleTools =
        activeCategory === "All Tools"
            ? toolsData
            : toolsData.filter((tool) => tool.type === activeCategory);

    return (
        <Space direction="vertical" size="large" style={{ padding: 20 }}>
            <Space wrap>
                {categories.map((cat) => (
                    <Button
                        key={cat}
                        type={activeCategory === cat ? "primary" : "default"}
                        shape="round"
                        onClick={() => setActiveCategory(cat)}
                    >
                        {cat}
                    </Button>
                ))}
                <UploadingImageModal trigger={<Button>upload</Button>} />
            </Space>

            <Row gutter={[16, 16]}>
                {visibleTools.map((tool) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={tool.key}>
                        <Card
                            hoverable
                            style={{ height: "100%" }}
                            styles={{ body: { padding: 16 } }}
                            onClick={() => onSelectTool?.(tool.key)}
                        >
                            <Space align="start" size="middle">
                                <Avatar
                                    size={32}
                                    style={{ background: "white" }}
                                    icon={tool.icon}
                                />
                                <Space direction="vertical" size="small">
                                    <Title level={5} style={{ margin: 0 }}>
                                        {tool.title}
                                    </Title>
                                    <Tag>{tool.category}</Tag>
                                    <Text type="secondary">
                                        {tool.description}
                                    </Text>
                                </Space>
                            </Space>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Space>
    );
};

export default ToolsGrid;
